import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import VehiclesTable from "../../../../component/admin/VehiclesTable";
import { useGetVendorDetailsQuery } from "../../../../store/api/school/VendorSlice";

const initialPagination = {
  limit: 10,
  page: 1,
  total: "",
  totalPages: "",
};

const VendorVehicleList = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [pagination, setPagination] = useState(initialPagination);
  const [vehicles, setVehicles] = useState([]);
  const { data, isSuccess, isLoading } = useGetVendorDetailsQuery({
    id,
    ...pagination,
  });

  useEffect(() => {
    if (isSuccess && data?.data) {
      setVehicles(data?.data?.vehicles);
      setPagination(data?.data?.pagination);
    }
  }, [isSuccess, data]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between">
        <div className="mb-2 total">
          {t("Total")} {t("vehicles")} : {pagination?.total}
        </div>
        <div className="mb-2 vandorInfo"></div>
      </div>

      <VehiclesTable
        vehicles={vehicles}
        isLoading={isLoading}
        pagination={pagination}
        setPagination={setPagination}
        isBooking={true}
      />
    </>
  );
};

export default VendorVehicleList;
